import { LOCALE } from 'utils';

import { FetchClient, storeClient } from '@/shared/api/client';

import { BindInpostPayResponse, CreateBindInpostPayResponse } from './types';

export const createBindInpostPay = async (
  basketId: string,
  locale: string,
  fetch?: FetchClient
): Promise<string | undefined> => {
  try {
    return await storeClient<CreateBindInpostPayResponse>(
      `/basket/bind-inpost-pay`,
      {
        method: 'POST',
        body: {
          basketId,
          locale,
        },
      },
      fetch
    ).then((response) => response.basketBindingApiKey);
  } catch (e) {
    return;
  }
};

export const bindInpostPay = async (
  basketId: string,
  locale: string,
  fetch?: FetchClient
): Promise<string | undefined> => {
  if (locale !== LOCALE.PL) return '';
  try {
    return await storeClient<BindInpostPayResponse>(
      `/basket/get-bind-inpost-pay`,
      {
        method: 'POST',
        body: {
          basketId,
        },
      },
      fetch
    ).then((response) => response.basket_binding_api_key);
  } catch (e) {
    return;
  }
};
